// lurik-frontend/src/use-cases/authentication/useCompanyTwoFactorService.ts
import { useState } from 'react';
import { useTwoFactorApi } from '../../infra/two-factor-api/useTwoFactorApi';
import { executeAlert } from "../../application/states/toast-alert"
import { useAppDispatch } from '../../application/states/hooks';
import { useTwoFactorService } from './useTwoFactorService';

export const useCompanyTwoFactorService = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  
  const twoFactorApi = useTwoFactorApi();
  const dispatch = useAppDispatch()
  const { activateTwoFactor } = useTwoFactorService();
  const configureCompanyTwoFactor = async (
    companyId: string,
    ownerUserId: string,
    enable: boolean,
    password: string
  ) => {
    try {
      setIsLoading(true);
      setError(null);
      
      const response = await twoFactorApi.configureCompanyTwoFactor({
        companyId,
        ownerUserId,
        enable,
        password
      });
      
      if (enable) {
        try {

          
          // ✅ FORÇAR ativação 2FA individual do OWNER
          const result = await activateTwoFactor(ownerUserId);
          
          // ✅ SALVAR dados no localStorage ANTES do redirect:
          localStorage.setItem('TWO_FACTOR_USER_ID', ownerUserId);
          localStorage.setItem('TWO_FACTOR_SECRET', result.secret);
          localStorage.setItem('TWO_FACTOR_QR_CODE', result.qrCodeUrl);
          localStorage.setItem('TWO_FACTOR_BACKUP_CODES', JSON.stringify(result.backupCodes));
          
          // ✅ REDIRECIONAR para página de configuração 2FA
          setTimeout(() => {
            window.location.href = '/two-factor';
          }, 2000);
          
        } catch (error) {
          console.error('Erro ao ativar 2FA individual:', error);
        }
      }
      
      const message = enable ? '2FA ativado para toda empresa! Redirecionando para configuração...' : '2FA desativado para toda empresa!';
      
      dispatch(executeAlert({
        type: 'success',
        message: response.message || message
      }));
      
      return response;
    } catch (err: any) {
      const errorMessage = err?.response?.data?.result?.message || 'Erro ao configurar 2FA da empresa';
      setError(errorMessage);
      dispatch(executeAlert({
        type: 'error',
        message: errorMessage
      }));
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    configureCompanyTwoFactor
  };
};